import { useSelector } from 'react-redux';

import { StoreState } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { AppState } from '../../store';
import { UserInputState } from '../../userInput';

export const useUserInput = (): UserInputState => {
	return useSelector((state: StoreState<AppState>) => state.appState.userInputState);
};
